import React, { useState, useEffect } from "react";
import { usePage } from "@inertiajs/react";
import logo from "../../../../images/bajaj-logo2.png";
import logo2 from "../../../../images/bajaj-logo.png";
import bajaj from "../../../../images/bajaj-banner.png";
import microsoft from "../../../../images/others/microsoft.png";
import logowhite from "../../../../images/logo-white.png";

interface PageProps {
    app?: {
        version: string;
    };
    [key: string]: any;
}

const Signin = () => {
    const { props } = usePage<PageProps>();
    const appVersion = props.app?.version;
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        // 1. Check URL parameters for error messages
        const urlParams = new URLSearchParams(window.location.search);
        const errorParam = urlParams.get("error");

        if (errorParam) {
            setError(decodeURIComponent(errorParam));
        }

        // 2. Check if there's a flash message stored in sessionStorage
        // (This would be set by the backend Laravel redirect)
        const flashError = sessionStorage.getItem("auth_error");
        if (flashError) {
            setError(flashError);
            // Clear the error after displaying it
            sessionStorage.removeItem("auth_error");
        }
    }, []);

    const handleSSOLogin = () => {
        // Show loading state
        setLoading(true);

        // Simulate SSO authentication process
        setTimeout(() => {
            // Here you would normally redirect to SSO provider
            //window.location.href = '/dashboard';
            window.location.href = "/auth/microsoft";
            //alert("Redirecting to SSO provider...");
            setLoading(false);
        }, 1500);
    };

    return (
        <>
            {/* Full Screen Loader */}
            {loading && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="flex flex-col items-center space-y-4">
                        <div className="flex h-40 items-center justify-center">
                            <div className="h-12 w-12 animate-spin rounded-full border-4 border-blue-500 border-t-transparent"></div>
                        </div>
                        <p className="text-white">Authenticating...</p>
                    </div>
                </div>
            )}

            {/* Main Content */}
            <div className="grid h-screen sm:grid-cols-1 lg:grid-cols-2">
                <div className="relative hidden items-center justify-center bg-blue-600 md:flex">
                    <div className="relative flex h-full w-full items-center justify-center bg-cover bg-center">
                        <div className="relative z-10 flex flex-col items-center justify-center space-y-4">
                            <div className="text-5xl font-bold text-white mb-4">
                                <div className="logos">
                                    <img
                                        src={logo}
                                        aria-label="Bajaj Auto Logo"
                                        alt="logoWhite"
                                        className="h-6 hidden dark:inline-block group-data-[layout=modern]:hidden"
                                        height={24}
                                        width={132}
                                    />
                                </div>
                            </div>
                            <div className="text-5xl font-bold text-white mb-4">
                                <div className="logos">
                                    <img
                                        src={bajaj}
                                        aria-label="Bajaj Auto Logo"
                                        alt="logo-blue"
                                        className="dark:inline-block group-data-[layout=modern]:hidden"
                                        width={500}
                                    />
                                </div>
                            </div>
                            <div className="text-center text-3xl font-bold text-white">
                                Bajaj CV Audit App
                            </div>
                        </div>
                        <div className="absolute bottom-4 text-white text-center w-full">
                            Version: {appVersion || "N/A"}
                        </div>
                    </div>
                </div>
                <div className="flex items-center justify-center bg-white p-6">
                    <div className="w-full max-w-sm">
                        {/* Logo */}
                        <div className="mb-8 flex justify-center">
                            <img
                                src={logo2}
                                alt="Bajaj Logo"
                                width={200}
                                className="inline-block"
                            />
                        </div>

                        <h2 className="mb-6 text-center text-2xl font-bold text-black">
                            Sign In
                        </h2>

                        {/* Error Display */}
                        {error && (
                            <div className="mb-6 rounded-md bg-red-100 p-4 text-red-700">
                                <p className="text-center break-words whitespace-normal">
                                    {error}
                                </p>
                            </div>
                        )}

                        <button
                            onClick={handleSSOLogin}
                            className="w-full rounded-md uppercase font-bold  bg-blue-500 px-4 py-3 text-white transition duration-200 hover:bg-blue-600 flex items-center justify-center"
                        >
                            <svg
                                className="w-5 h-5 me-4"
                                viewBox="0 0 21 21"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <rect
                                    x="1"
                                    y="1"
                                    width="9"
                                    height="9"
                                    fill="#f25022"
                                />
                                <rect
                                    x="1"
                                    y="11"
                                    width="9"
                                    height="9"
                                    fill="#00a4ef"
                                />
                                <rect
                                    x="11"
                                    y="1"
                                    width="9"
                                    height="9"
                                    fill="#7fba00"
                                />
                                <rect
                                    x="11"
                                    y="11"
                                    width="9"
                                    height="9"
                                    fill="#ffb900"
                                />
                            </svg>
                            <span className="font-medium">
                                Sign in with SSO
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Signin;
